namespace Matrix.Workflow {
    export interface DataQualityWorkflowForm {
        WorkflowCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Class1: Serenity.StringEditor;
        Key1Name: Serenity.StringEditor;
        Key2Name: Serenity.StringEditor;
        C1Name: Serenity.StringEditor;
        N1Name: Serenity.StringEditor;
        D1Name: Serenity.StringEditor;
        Txt1Name: Serenity.StringEditor;
        Txt1: Serenity.TextAreaEditor;
        Txt2Name: Serenity.StringEditor;
        Txt3Name: Serenity.StringEditor;
        IsEnabled: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class DataQualityWorkflowForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.DataQualityWorkflow';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataQualityWorkflowForm.init)  {
                DataQualityWorkflowForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.BooleanEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(DataQualityWorkflowForm, [
                    'WorkflowCode', w0,
                    'Description', w0,
                    'Class1', w0,
                    'Key1Name', w0,
                    'Key2Name', w0,
                    'C1Name', w0,
                    'N1Name', w0,
                    'D1Name', w0,
                    'Txt1Name', w0,
                    'Txt1', w1,
                    'Txt2Name', w0,
                    'Txt3Name', w0,
                    'IsEnabled', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
